import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'cosmos-auth-layout',
  imports: [TranslatePipe, DividerModule],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {
  /** Page-specific title shown in the right panel header. */
  @Input() title = '';

  /** Page-specific subtitle shown below the title. */
  @Input() subtitle = '';

  private readonly _lsName = signal(
    typeof window !== 'undefined'
      ? (localStorage.getItem('ui.theme.customName') ?? '')
      : ''
  );
  protected readonly customBrandName = computed(() => this._lsName());
}
